



















import { Vue, Component, Prop } from 'nuxt-property-decorator';
import UniversalSearchResultsItem from '@/components/common/UniversalSearch/UniversalSearchResults/UniversalSearchResultsItem.vue';
import type { Company } from '@/types/graphql';

const humanize = (value: string) => value.replace(/_/g, ' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase());

@Component<UniversalSearchResultsCompany>({
  components: {
    UniversalSearchResultsItem,
  },
})
export default class UniversalSearchResultsCompany extends Vue {
  @Prop({ default: false }) removable!: boolean;
  @Prop({ required: true }) item!: { company: Company };

  get name() {
    return this.item.company.name;
  }

  get description() {
    return humanize(this.item.company.investmentRound ?? '');
  }
}
